export default __webpack_public_path__ + "static/media/logo.07247771.svg";